module.exports = __webpack_public_path__ + "static/media/galaxy.0664e01e.svg";